export default {
    currentComponent: "cadastroLeitura"
}